import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('solicitudes-inscripciones'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-inscripciones'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`solicitudes-inscripciones/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`solicitudes-inscripciones/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`solicitudes-inscripciones/${id}`));
  },
  async findAllPaginado(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-inscripciones/paginado'), { params: opciones.params });
  },
  async aprobar(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`solicitudes-inscripciones/${id}/aprobar`), data);
  },
};
